import axios from 'axios';

export const CLAIM_REPORTING_SOURCES = [
  { workflow: 'Vehicle Damage', key: 'vehicle', endpoints: { reported: '/get_submitted_open_forms', processing: '/get_claim_processing_forms', closed: '/get_closed_forms' } },
  { workflow: 'Windshield / Tire', key: 'windshield', endpoints: { reported: '/get_submitted_windshield_tire_open_forms', processing: '/get_windshield_tire_claim_processing_forms', closed: '/get_closed_windshield_tire_forms' } },
  { workflow: 'Shuttle Bus', key: 'shuttle', endpoints: { reported: '/get_submitted_shuttle_bus_open_forms', processing: '/get_shuttle_bus_claim_processing_forms', closed: '/get_closed_shuttle_bus_forms' } },
];

export const normalizeAssignedLocations = (value) => (
  Array.isArray(value) ? value : String(value || '').split(',')
).map((item) => String(item).trim()).filter(Boolean);

export const getClaimLocation = (row) => String(
  row?.branchLocationCode
  || row?.claimOwningBranch
  || row?.location_name
  || row?.reported_claim?.branchLocationCode
  || 'Unassigned'
).trim() || 'Unassigned';

export const getClaimDate = (row) => {
  const value = row?.closed_datetime || row?.updated_datetime || row?.created_datetime || row?.reportDateTime || row?.accidentDate;
  if (!value) return null;
  const direct = new Date(value);
  if (!Number.isNaN(direct.getTime())) return direct;
  const match = String(value).match(/^(\d{2})-(\d{2})-(\d{4})/);
  return match ? new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1])) : null;
};

const isClosed = (row) => Boolean(
  row?.closure_completed || row?.claim_status === 'Completed' || row?.claim_workflow_stage === 'closed'
);

export const fetchClaimsReportingData = async (baseURL) => {
  const requests = CLAIM_REPORTING_SOURCES.flatMap((source) =>
    Object.entries(source.endpoints).map(([stage, endpoint]) => ({ source, stage, endpoint }))
  );
  const responses = await Promise.all(requests.map((item) => axios.get(`${baseURL}${item.endpoint}`)));
  return responses.flatMap((response, index) => {
    const request = requests[index];
    return (Array.isArray(response.data) ? response.data : []).map((row) => ({
      ...row,
      reportingWorkflow: request.source.workflow,
      reportingWorkflowKey: request.source.key,
      reportingStage: request.stage === 'closed' ? (isClosed(row) ? 'closed' : 'pendingClose') : request.stage,
      reportingLocation: getClaimLocation(row),
    }));
  });
};
